window.contactValidationTwMessage = {
    ask_the_topic: {
        required: "This Field Is Required.",
    },
    content: {
        required: "This Field Is Required.",
        maxlength: "Exceeded Character Limit",
    },
    name: {
        required: "This Field Is Required.",
        maxlength: "Exceeded Character Limit",
    },
    company_name: {
        maxlength: "Exceeded Character Limit",
    },
    address: {
        maxlength: "Exceeded Character Limit",
    },
    email: {
        required: "This Field Is Required.",
        email: "Must Be Valid Email.",
        maxlength: "Exceeded Character Limit",
    },
    tel: {
        maxlength: "Exceeded Character Limit",
        tel: "Must Be Valid Phone Number.",
    },
    privacy: {
        required: "Please check to agree to the privacy policy.",
    },
};
